// Hidden per LMP-5588: to restore, uncomment usage in SystemSettingsTab.tsx / CoachSystemSettingsTab.tsx
// AND <ngz-notification-modals> in src/index.html (widget is inert without it).
import React from 'react';

import { observer } from 'mobx-react';

import { InfoBox } from '@infoods/lifebase-ui';
import { angularizeWithProviders } from '../../../shared/providers';
import { NotificationsSettingsItem } from './NotificationsSettingsItem/NotificationsSettingsItem';
import { whatsNewStore } from '../../store/whatsNewStore';
import { challengeTutorialStore } from '../../store/challengeTutorialStore';

const NgzNotificationsSettings = observer(() => {
  return (
    <InfoBox title="Notifications" customContentPadding>
      <NotificationsSettingsItem
        title="Turn on challenge tutorial"
        description="The challenge tutorial will appear each time when you're opening the dashboard."
        checked={challengeTutorialStore.showAgain}
        onChange={(showAgain) => challengeTutorialStore.changeShowAgain(showAgain)}
        extraActionTitle="Watch Tutorial Video"
        onExtraAction={() => challengeTutorialStore.openModal('VIEW', true)}
      />
      <NotificationsSettingsItem
        title="Important Updates & Features"
        description="Displays notifications about new releases, feature updates, and improvements."
        checked
        switchDisabled
        extraActionTitle="Open Current Updates"
        onExtraAction={whatsNewStore.openModal}
      />
    </InfoBox>
  );
});

angularizeWithProviders(NgzNotificationsSettings, 'ngzNotificationsSettings', {});

export { NgzNotificationsSettings };
